module.exports = __webpack_public_path__ + "static/media/u_64k.87a48855.mp3";